import React from 'react';
import { useState} from 'react';
import { AddFeatureFlag } from '../../api/Api';
import { useForm, FormProvider } from "react-hook-form";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { addedFeatureFlag } from '../../Models/AddFeatureFlagRequest';
import CredentialComponent from './CredentialComponent';
import Card from '../Card/Card';
import { authCredentials } from '../../Models/AuthCredentials';

function AddFeatureFlagForm(){

    const [showAlert, setShowAlert] = useState(false);
    const [alertData, setAlertData] = useState({});

    const methods = useForm();
    const { handleSubmit, register, reset } = methods;

    async function onSubmit(data){
        let newFlag = new addedFeatureFlag(data.flagDescription, data.enabledForAll, data.username, data.flagName, data.serviceName);
        let credentials = new authCredentials(data.username, data.password);

        try {
            let response = await AddFeatureFlag(newFlag, credentials);
            handleResponse(response);
        } catch (err) {
            handleResponse(err.response);
        }
    }

    function handleResponse(response){
        if (response.status === 200) {
            setShowAlert(true);
            let data = {
                variant: 'primary',
                heading: `Request status: ${response.status}`,
                message: response = "The Flag has been added successfully"
            }
            reset();
            setAlertData(data);
        }
        else if (response.status === 204) {
            setShowAlert(true);
            let data = {
                variant: 'warning',
                heading: `Request status: ${response.status}`,
                message: response = "The Flag already exists. No changes were made."
            }
            setAlertData(data);
        } else if (response.status === 400){
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:"Invalid Login"
            }
            setAlertData(data);
        } else if (response.status === 401){
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:"User is not authorized"
            }
            setAlertData(data);
        } else {
            setShowAlert(true);
            let data = {
                variant:"danger", 
                heading:`Request status: ${response.status}`, 
                message:response=response.data.Message
            }
            setAlertData(data);
        }
    }

    return (
        <section >
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group>
                        <Form.Label>Flag Name</Form.Label>
                        <Form.Control type='text' required name="flagName" {...register('flagName')} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Service Name</Form.Label>
                        <Form.Control type='text' required name="serviceName" {...register('serviceName')} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Flag Description</Form.Label>
                        <Form.Control type='text' required name="flagDescription" {...register('flagDescription')} />
                    </Form.Group>
                    <CredentialComponent />
                    <Form.Group>
                        <Form.Check type='checkbox' name="enabledForAll" {...register('enabledForAll')} label="EnabledForAll"/>
                    </Form.Group>
                    <Button variant='secondary' type='submit'>Submit</Button>
                </Form>
            </FormProvider>
            <br />
            <Card show={showAlert} variant={alertData.variant} heading={alertData.heading} message={alertData.message}></Card>
        </section>
    );
}



export default AddFeatureFlagForm;